export const selectAdmin = (state) => state.admin;
export const selectAdminList = (state) => state.admin.list;
export const selectAdminLoading = (state) => state.admin.loading;
export const selectAdminError = (state) => state.admin.error;
export const selectAdminUpdateLoading = (state) => state.admin.updateLoading;

export const selectAdminUpdateError = (state) => state.admin.updateError;
